/**
 * Developer-configurable Brain chat surfaces (FE).
 * Ops is live; sales/marketing/management are scaffolded for BrainChatShell.
 */

export const BRAIN_CHAT_SURFACES = {
  ops_template_chat: {
    id: 'ops_template_chat',
    vertical: 'operations',
    title: 'Create with AI',
    subtitle:
      'Create Common / Independent / Group task templates from scratch — voice or text, then confirm missing details.',
    placeholder:
      'e.g. Foundation Common tasks for a G+12 residential tower with shuttering and curing…',
    supportsApply: true,
    applyLabel: 'Apply proposed tasks'
  },
  sales_assist: {
    id: 'sales_assist',
    vertical: 'sales',
    title: 'Sales Assist',
    subtitle: 'Lead follow-ups, objections, and pipeline coaching — grounded in chat context.',
    placeholder: 'e.g. Draft a warm follow-up for a site-visit no-show…',
    supportsApply: false,
    applyLabel: null
  },
  marketing_assist: {
    id: 'marketing_assist',
    vertical: 'marketing',
    title: 'Marketing Assist',
    subtitle: 'Campaign copy and channel ideas grounded in project context.',
    placeholder: 'e.g. LinkedIn launch teaser for our new 2BHK inventory…',
    supportsApply: false,
    applyLabel: null
  },
  management_assist: {
    id: 'management_assist',
    vertical: 'management',
    title: 'Management Assist',
    subtitle: 'Priorities and summaries across ops and sales signals.',
    placeholder: 'e.g. What should leadership focus on this week for Project X?',
    supportsApply: false,
    applyLabel: null
  }
};

export function getBrainChatSurface(surfaceId) {
  if (!surfaceId) return null;
  return BRAIN_CHAT_SURFACES[String(surfaceId).trim()] || null;
}

export function listBrainChatSurfaces(vertical = null) {
  const all = Object.values(BRAIN_CHAT_SURFACES);
  if (!vertical) return all;
  return all.filter((s) => s.vertical === String(vertical).trim());
}
